import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { AnalysesTypesLowercase } from 'src/app/analyses/interfaces/analyses.types';
import { AnalysisLink } from '../../shared.types';

@Component({
  selector: 'app-new-analyses-list',
  templateUrl: './new-analyses-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NewAnalysesListComponent implements OnInit {
  @Input() type: AnalysesTypesLowercase;
  @Input() analyses: AnalysisLink[];
  @Input() hideCircles = false;

  public newAnalyses: AnalysisLink[];

  ngOnInit(): void {
    this.newAnalyses = this.analyses.filter((analysis) => analysis?.isNew);
  }
}
